import { setAttendeeDetails } from '@shoflo/studio-redux/actions';
import { updateSource } from 'actions/source';
import { SOURCE_ROLE_SPEAKER } from '@shoflo/polymer';

function knockUpdated(
  { dispatch, getState },
  { attendeeId, name, description, presenterPhoto, cameraUnavailable }
) {
  dispatch(
    setAttendeeDetails(
      attendeeId,
      name,
      description,
      presenterPhoto,
      SOURCE_ROLE_SPEAKER
    )
  );
  const { broadcastSources } = getState();
  const presenter = broadcastSources.sources.find(
    ({ value }) => value === attendeeId
  );

  if (presenter) {
    const payload = {
      title: name,
      description,
      cameraUnavailable
    };
    dispatch(updateSource(presenter._id, payload));
  }
}

export default knockUpdated;
